<template>
  <div>
     <div v-html="examHtml" v-if="payType==6"></div>
     <div v-else style="padding-top: 100px; margin:0 auto 0;text-align: center;">
        <h2 style="text-align: center;margin: 0;">微信支付</h2>
        <img style="width: 200px;" :src="examHtml">
     </div>
  </div>
</template>

<script>
import { coursePay } from '../../api/userMG'
export default {
  data() {
    return {
      payType:6,
      orderId:'',
      examHtml:''
    }
  },

  created() {
    // this.generateQRCode()
    this.payType = this.$route.query.payType;
    this.orderId = this.$route.query.orderId;
    console.log('payType',this.payType)
    console.log('orderId',this.orderId)
    this.submitCoupon();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    submitCoupon(){
      let params = {
        payType:this.payType,
        orderId:this.orderId
      }
      coursePay(params).then(res => {
        console.log('支付',res);
        if(res.code==0){
          this.examHtml = res.data;
          if(this.payType==6){
            setTimeout(() => {
              document.forms[0].submit();
            }, 100)
          }
        }
      })
      .catch(err => {
      })
    }
  }
}
</script>

<style scoped>

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Orderz.vue